import * as net from 'util/Net';

import {ServerDocumentEditorLock} from './DocumentEditorLockConstants';

export function acquireLock(documentId: string): Promise<ServerDocumentEditorLock | null> {
  return net.postJSONPromise({
    url: `/1/api/document-editor-lock/acquire_lock`,
    data: {documentId},
  });
}

export function releaseLock(documentId: string): Promise<ServerDocumentEditorLock | null> {
  return net.postJSONPromise({
    url: `/1/api/document-editor-lock/release_lock`,
    data: {documentId},
  });
}

export function fetchLock(documentId: string): Promise<ServerDocumentEditorLock | null> {
  return net.postJSONPromise({
    url: `/1/api/document-editor-lock/fetch_lock`,
    data: {documentId},
  });
}
